import { right } from "@popperjs/core";


class CTA {

    ctas: NodeListOf<Element> = document.querySelectorAll('.cta.pl-v2');
    fullWidthCtas: NodeListOf<Element> = document.querySelectorAll('.cta-full-width');
    constructor() {
        this.init();
        window.addEventListener('resize', () => this.init());
    }

    init() {
        if (this.ctas.length === 0) return;
        this.ctas.forEach((cta) => {
            // only do this above medium breakpoint
            const mq = window.matchMedia('(min-width: 768px)');
            if (!mq.matches) return;

            // get the col-content and col-image elements
            const colContent = cta.querySelector('.col-content') as HTMLElement;
            const colImage = cta.querySelector('.col-image') as HTMLElement;

            if (!colContent || !colImage) return;
            // get the height of the col-content
            const contentHeight = colContent.offsetHeight;

            // set the height of the col-image to match col-content + 80PX 
            colImage.style.height = `${contentHeight + 80}px`;
        });

        if (this.fullWidthCtas.length === 0) return;
        this.fullWidthCtas.forEach((cta) => {
            const video = cta.querySelector('video') as HTMLVideoElement;
            if (!video) return;

            const container = cta.querySelector('.container') as HTMLElement;

            const btnWrapper = cta.querySelector('.btn-wrapper') as HTMLElement;
            if (!container || !btnWrapper) return;

            const containerRect = container.getBoundingClientRect();
            const ctaRect = cta.getBoundingClientRect();

            let rightPosition = ctaRect.right - containerRect.right;


            const mqSm = window.matchMedia('(max-width: 575.98px)');
            const mqMd = window.matchMedia('(min-width: 576px) and (max-width: 767.98px)');
            const mqLg = window.matchMedia('(min-width: 768px) and (max-width: 991.98px)');
            const mqXl = window.matchMedia('(min-width: 992px)');
            
            let bottom = 32; // Default fallback
            const content = cta.querySelector('.content-wrapper .content') as HTMLElement;
            const btnHeight = btnWrapper.querySelector('button')?.offsetHeight || 0;
            
            
            if (mqSm.matches) {
                const contentHeight = content ? content.offsetHeight : 0;
                bottom = contentHeight + 20;
                rightPosition += 16; 
            } else if (mqMd.matches ) {
                const afterHeight = window.getComputedStyle(content, '::after').height.replace('px', '');
                bottom = parseInt(afterHeight) + 20;
                rightPosition += 16; 
            } else if (mqLg.matches) {
                const afterHeight = window.getComputedStyle(content, '::after').height.replace('px', '');
                bottom = parseInt(afterHeight) + btnHeight + 20;
            } else if (mqXl.matches) {
                bottom = 32;
            }

            btnWrapper.style.right = `${rightPosition}px`; 
            btnWrapper.style.bottom = `${bottom}px`;

            const btnPlayPause = btnWrapper.querySelector('.btnPlayPause') as HTMLButtonElement;
            if (!btnPlayPause) return;

            btnPlayPause.addEventListener('click', () => {
                if (video.paused) {
                    video.play();
                    btnPlayPause.querySelector('.play')?.classList.add('d-none');
                    btnPlayPause.querySelector('.pause')?.classList.remove('d-none');
                    
                    btnPlayPause.querySelector('span').innerText = 'Pause';

                } else {
                    video.pause();
                    btnPlayPause.querySelector('.play')?.classList.remove('d-none');
                    btnPlayPause.querySelector('.pause')?.classList.add('d-none');

                    btnPlayPause.querySelector('span').innerText = 'Play';

                }
            });
        });

    }
}

export default CTA;